import { useTranslation } from 'react-i18next'

import { CancelOpportunityErrorModalProps } from '../ErrorModal/CancelOpportunityErrorModal.types'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export function CancelOpportunitySuccessModal({
  open,
  handleClose
}: Readonly<Omit<CancelOpportunityErrorModalProps, 'errorCode'>>) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="cancel-opportunity-success"
      data-testid="cancel-opportunity-success-modal"
    >
      <AcknowledgeModal
        result="positive"
        title={t('dialog.volunteering.cancel.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="success-modal-btn"
      >
        {t('dialog.volunteering.cancel.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
